import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { configData } from "../Navbar/config";
import "../BreadCrumb/BreadCrumb.css";
import { navigationTree } from "../Sidebar/Service";
import { useAuth } from "../../authContext/AuthContext";
import profileIcon from "../../common/assets/images/profile-user.png";

const Breadcrumb = ({ sidebarOpen }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const [navData, setNavData] = useState([]);
  const { userEmail } = useAuth();

  useEffect(() => {
    navigationTree().then((data) => {
      setNavData(data);
    });
  }, []);

  if (location.pathname === "/") return null;

  // 🧩 Helper to recursively find breadcrumb trail
  const findBreadcrumbTrail = (items, target, trail = []) => {
    for (const item of items) {
      const newTrail = [...trail];

      // Handle parents (main router)
      if (item.children) {
        const parentTrail = item.main_Router
          ? [
              ...newTrail,
              {
                name: item.main_Router,
                path: item.path ? `/${item.path}` : null, // 👈 clickable if path exists
                isMain: true,
              },
            ]
          : [...newTrail];

        const child = item.children.find(
          (child) => child.path?.toLowerCase() === target?.toLowerCase()
        );

        if (child) {
          return [
            ...parentTrail,
            { name: child.name, path: `/${child.path}` },
          ];
        }

        // Recursive search
        for (const child of item.children) {
          if (child.children) {
            const result = findBreadcrumbTrail(
              [{ ...child, main_Router: null }],
              target,
              parentTrail.concat({
                name: child.name,
                path: child.path ? `/${child.path}` : null,
              })
            );
            if (result.length) return result;
          }
        }
      }

      // Handle standalone items
      if (item.path?.toLowerCase() === target?.toLowerCase()) {
        return [
          ...newTrail,
          { name: item.name, path: `/${item.path}`, isMain: false },
        ];
      }
    }

    return [];
  };

  // 🧩 Build breadcrumb trail from segments
  const getBreadcrumbTrail = (segments) => {
    let trail = [];
    segments.forEach((segment) => {
      const foundTrail = findBreadcrumbTrail(configData, segment);
      trail = [...trail, ...foundTrail];
    });
    return trail;
  };

  const breadcrumbs = getBreadcrumbTrail(pathSegments);

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
      <ol className="breadcrumb d-flex align-items-center">
        <Link className="breadcrumb-item" to="/">
          Home
        </Link>

        {breadcrumbs.length > 0 && <span className="mx-2">{">"}</span>}

        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={index}>
            {breadcrumb.path ? (
              <Link style={{cursor:"pointer"}} className="breadcrumb-item" to={breadcrumb.path}>
                {breadcrumb.name}
              </Link>
            ) : (
              <span className="breadcrumb-item text-muted">
                {breadcrumb.name}
              </span>
            )}
            {index < breadcrumbs.length - 1 && (
              <span className="mx-2">{">"}</span>
            )}
          </React.Fragment>
        ))}
      </ol>

      {/* Profile Section */}
      <div className="d-flex gap-2 align-items-center">
        <img src={profileIcon} alt="profile" style={{ height: "24px" }} />
        <span
          style={{
            marginRight: sidebarOpen ? "225px" : "125px",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {userEmail}
        </span>
      </div>
    </nav>
  );
};

export default Breadcrumb;
